import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import FeedView from 'applications/sports/pages/home-page/feed-view/index.js';
import ProView from 'applications/sports/pages/home-page/pro-view/index.js';

const { types: SystemSettingsTypes, selectors: systemSettingsSelectors } =
    MojitoCore.Services.SystemSettings;
const { HOME_DEFAULT_VIEW } = SystemSettingsTypes;

const {
    FlexPane,
    DocumentHead,
    GlobalLinks,
    PageSplitLayout,
    DefaultHeadMetaFactory,
    Portal,
    SelectableButtonGroup,
    SelectableButton,
    Image,
    Text,
} = MojitoPresentation.Components;
const PageContextMenu = MojitoModules.PageContextMenu;
const SportsMenu = MojitoModules.SportsMenu.module;
const SportsFilterContainer = MojitoModules.SportsFilterContainer.module;

const HomePageAvantgarde = props => {
    const { mojitoTools } = props;
    const { config, style, l10n, stringResolver } = mojitoTools;
    const homeDefaultView =
        useSelector(systemSettingsSelectors.selectHomeDefaultView) ?? HOME_DEFAULT_VIEW.FEED;
    const [selectedTab, setSelectedTab] = useState(homeDefaultView);

    useEffect(() => {
        setSelectedTab(homeDefaultView);
    }, [homeDefaultView]);
    const metaFactory = config.documentHeadMetaFactory || DefaultHeadMetaFactory;
    const documentHeadMetaFactory = useMemo(() => new metaFactory(l10n), [metaFactory, l10n]);
    const headData = {
        title: '$HOME_PAGE_CLASSIC.PAGE_TITLE',
        keywords: '$HOME_PAGE_CLASSIC.PAGE_KEYWORDS',
        description: '$HOME_PAGE_CLASSIC.PAGE_DESCRIPTION',
        canonical: '$HOME_PAGE_CLASSIC.PAGE_CANONICAL',
    };

    return (
        <>
            <DocumentHead data={headData} metaFactory={documentHeadMetaFactory} />
            <Portal config={config.feedProSwitchPortal}>
                <SelectableButtonGroup
                    selectedKey={selectedTab}
                    onSelectionChange={setSelectedTab}
                    config={config.feedProSwitch}
                >
                    <SelectableButton selectableKey={HOME_DEFAULT_VIEW.FEED}>
                        <Image
                            config={
                                selectedTab === HOME_DEFAULT_VIEW.FEED
                                    ? style.feedTabIconSelected
                                    : style.feedTabIcon
                            }
                        />
                        <Text config={style.feedTabLabel}>
                            {stringResolver.resolveString('$HOME_PAGE_AVANTGARDE.FEED_TAB')}
                        </Text>
                    </SelectableButton>
                    <SelectableButton selectableKey={HOME_DEFAULT_VIEW.PRO}>
                        <Image
                            config={
                                selectedTab === HOME_DEFAULT_VIEW.PRO
                                    ? style.proTabIconSelected
                                    : style.proTabIcon
                            }
                        />
                        <Text config={style.proTabLabel}>
                            {stringResolver.resolveString('$HOME_PAGE_AVANTGARDE.PRO_TAB')}
                        </Text>
                    </SelectableButton>
                </SelectableButtonGroup>
            </Portal>
            <PageSplitLayout>
                <FlexPane
                    config={config.primaryContentContainer}
                    class="ta-primaryContentContainer"
                >
                    {selectedTab === HOME_DEFAULT_VIEW.FEED && (
                        <SportsFilterContainer config={config.sportsFilter}>
                            {(selectedSportId, applySports) => (
                                <FeedView
                                    config={config.feedView}
                                    selectedSportId={selectedSportId}
                                    onSportsLoad={applySports}
                                />
                            )}
                        </SportsFilterContainer>
                    )}
                    {selectedTab === HOME_DEFAULT_VIEW.PRO && <ProView config={config.proView} />}
                </FlexPane>

                <FlexPane config={config.secondaryContentContainer}>
                    <PageContextMenu config={config.leftContextMenu} applicablePage={'homepage'} />
                    <SportsMenu config={config.sportsMenu} />
                    <GlobalLinks />
                </FlexPane>
            </PageSplitLayout>
        </>
    );
};

HomePageAvantgarde.getStyle = (config, mode, merge) => ({
    margin: config.margin,
    display: 'flex',
    flexDirection: 'column',
    feedTabIcon: merge(config.tabIcon, config.feedTabIcon),
    proTabIcon: merge(config.tabIcon, config.proTabIcon),
    feedTabIconSelected: merge(config.tabIcon, config.feedTabIcon, config.feedTabIconSelected),
    proTabIconSelected: merge(config.tabIcon, config.proTabIcon, config.proTabIconSelected),
    feedTabLabel: merge(config.tabLabel, config.feedTabLabel),
    proTabLabel: merge(config.tabLabel, config.proTabLabel),
});

export default HomePageAvantgarde;
